export default __webpack_public_path__ + "static/media/offers-img.d365cd3c.jpg";